"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IbanFormWithMandat = void 0;

var react_1 = __importDefault(require("react"));

var Iban_1 = __importDefault(require("../../models/Iban"));

var IbanWithMandatPaymentAuto_1 = __importDefault(require("../../models/IbanWithMandatPaymentAuto"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var Form_1 = __importDefault(require("../Form/Form"));

var Input_1 = __importDefault(require("../Form/Input"));

var clsx_1 = __importDefault(require("clsx"));

var checkHasErrorIban_1 = __importDefault(require("../../utils/checkHasErrorIban"));

exports.IbanFormWithMandat = function (_a) {
  var e_1, _b;

  var _c = _a.iban,
      iban = _c === void 0 ? "" : _c,
      loaderSubmit = _a.loaderSubmit,
      messageError = _a.messageError,
      onSubmit = _a.onSubmit,
      _d = _a.modeOfPayment,
      modeOfPayment = _d === void 0 ? "paymentEtip" : _d;
  var currentModel = Iban_1.default;

  if (modeOfPayment === "paymentAuto") {
    currentModel = IbanWithMandatPaymentAuto_1.default;
  }

  if (modeOfPayment === "paymentEtip") {
    delete currentModel.civility;
    delete currentModel.mobile_phone;
  }

  var last_name = Iban_1.default.last_name,
      first_name = Iban_1.default.first_name,
      mobile_phone = Iban_1.default.mobile_phone,
      civility = Iban_1.default.civility,
      iban_props = __rest(Iban_1.default, ["last_name", "first_name", "mobile_phone", "civility"]);

  var holder = IbanWithMandatPaymentAuto_1.default.holder;
  var refsInput = {};

  try {
    for (var _e = __values(Object.keys(iban_props)), _f = _e.next(); !_f.done; _f = _e.next()) {
      var name_1 = _f.value;
      refsInput[name_1] = react_1.default.useRef(null);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var onchangeIbanFields = function onchangeIbanFields(e) {
    var _a = e.target,
        value = _a.value,
        name = _a.name;
    var reg = /^.{4}$/;
    var nextIndex = Object.keys(iban_props).indexOf(name) + 2;
    var inputLength = Object.keys(iban_props).length;
    var nextRefIndex = "iban_field_" + nextIndex;

    if (reg.test(value)) {
      var nextValue = refsInput[nextRefIndex].current.value;

      if (nextIndex < inputLength + 1 && value.length > 0 && !nextValue) {
        refsInput[nextRefIndex].current.focus();
      }
    }
  };

  var i = 0;
  var displayIbanFields = Object.keys(iban_props).map(function (name) {
    i++;
    return react_1.default.createElement(Input_1.default, __assign({
      key: name,
      ref: refsInput[name],
      showSpecificError: false,
      valid: false,
      changeCase: "upperCase",
      name: name,
      onChange: onchangeIbanFields
    }, iban_props[name], {
      className: clsx_1.default("cy-input-" + i + "-iban", "col-3 col-md-1 px-1 mx-2")
    }));
  });
  var labelIban = "Veuillez saisir vos coordonnées de compte IBAN";
  return react_1.default.createElement(Form_1.default, {
    onSubmit: onSubmit,
    validationSchema: currentModel,
    initialValues: {}
  }, function (_a) {
    var values = _a.values,
        isValid = _a.isValid,
        errors = _a.errors,
        setFieldValue = _a.setFieldValue,
        props = __rest(_a, ["values", "isValid", "errors", "setFieldValue"]);

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "bold",
      className: "title-page mb-0 col-md-12 col-12"
    }, "Coordonn\xE9es bancaires")), react_1.default.createElement("div", {
      className: "row mt-2 mb-4"
    }, modeOfPayment === "paymentAuto" && react_1.default.createElement(Input_1.default, __assign({
      name: "holder",
      changeCase: "upperCase"
    }, holder, {
      className: "cy-holder col-md-4"
    })), modeOfPayment === "paymentEtip" && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Input_1.default, __assign({
      name: "last_name",
      changeCase: "upperCase"
    }, last_name, {
      className: "cy-last-name col-md-4"
    })), react_1.default.createElement(Input_1.default, __assign({
      name: "first_name",
      changeCase: "upperCase"
    }, first_name, {
      className: "cy-first-name col-md-4"
    })))), react_1.default.createElement("div", {
      className: "row my-3"
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "regular",
      className: "col-md-12 title-page " + (iban ? "mb-2" : "mb-3")
    }, labelIban), displayIbanFields, react_1.default.createElement("div", {
      className: clsx_1.default("col-12", {
        "d-none": !checkHasErrorIban_1.default(values)
      })
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "danger"
    }, "Valeur incorrecte"))), react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement("div", {
      className: "col-md-12"
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "info",
      transparent: true,
      className: "py-2"
    }, "Les finalit\xE9s du traitement relatif \xE0 vos donn\xE9es personnelles, num\xE9riques et t\xE9l\xE9phoniques, ainsi que les destinataires de ce traitement et l\u2019\xE9tendue de vos droits sont consultables dans les conditions d'utilisation du site.", react_1.default.createElement("br", null), "Si vous souhaitez utiliser un compte qui n\u2019est pas domicili\xE9 en France ou Monaco , nous vous invitons \xE0 contacter le Service Client."))), messageError && react_1.default.createElement("div", {
      className: "row",
      style: {
        marginLeft: "-4.6rem",
        marginRight: "-4.6rem",
        background: "var(--gray-0)",
        padding: "1rem 4.6rem"
      }
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "danger",
      className: "col-12 mb-0"
    }, messageError)), react_1.default.createElement("div", {
      className: "row position-relative justify-content-between",
      style: {
        marginLeft: "-4.6rem",
        marginRight: "-4.6rem",
        background: "var(--gray-0)",
        padding: "1rem 4.6rem"
      }
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      loader: loaderSubmit,
      className: "cy-btn-submit col-7 col-md-3 ml-auto",
      isDisabled: !isValid,
      type: "submit"
    }, "Etape suivante")));
  });
};

exports.default = exports.IbanFormWithMandat;